<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        :persistent="true"
        width="60%"
        height="100%"
        class="modalDialog"
        no-click-animation
    >
      <v-card class="cardWrap">
        <CardTitle :title="page_title" />
            <v-row justify="space-around" class="titleMaxWidth">
                <div class="cardWrap__fromArea__title">氏名</div>
                <v-text-field class="px-3" :value="full_name" disabled />
            </v-row>
            <v-data-table class="modalDataTable"
                :items="desserts"
                :headers="headers"
                hide-default-footer
            >
                <template v-slot:[`item.card_no`]="{ item }">
                    {{ item.card_no }}
                </template>
                <template v-slot:[`item.Btn`]="{ item }">
                    <div class="buttonCell">
                        <a
                            @click="editModalDisplayOn(item)"
                            class="editBtn"
                            :class="{ 'disabled-btn': btn[1].isActive }">変更</a>
                        <a
                            @click="removeOverlayStart(item)"
                            class="deleteBtn"
                            :class="{ 'disabled-btn': btn[2].isActive }">削除</a>
                    </div>
                </template>
            </v-data-table>
            <v-pagination
                class="my-2"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
                @input="clickPagination"
            />
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
            <v-btn color="blue  darken-4" text @click="addModalDisplayOn" :disabled="btn[0].isActive">追加</v-btn>
        </v-card-actions>
        <RemoveOverlay
            page-name="カード番号"
            @processing="deleteMemberCardNo"
            @cancel="removeOverlay = !removeOverlay"
            :dblclickStop="processing"
            :process-result="process"
            :OverlaySwitch="removeOverlay"
        />
        <MemberCardNoModal
            ref="Modal"
            :editInfo="Info"
            :name="full_name"
            :MemNo="member_no"
            @refresh-event="getMemberCardList"
            :golf_courses="golfCourseSelection"
            :golf_code="golfCourseInput"></MemberCardNoModal>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';

import {
    GET_MEMBER_CARD_LIST,
    DELETE_MEMBER_CARD_NO
} from '@/constants/member_card';
import { ListPageMixin } from '@/views/Member/ListPageMixin.js';
import MemberCardNoModal from './dialog/MemberCardNoModal';
import RemoveOverlay from '../../Master/page/overlay/RemoveOverlay';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        CardTitle,
        RemoveOverlay,
        MemberCardNoModal
    },
    mixins: [ListPageMixin, authorityMixin],
    props: [
        'golfCourseSelection',
        'golfCourseInput'
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            removeOverlay: false,
            // ページタイトル
            page_title: 'カードNo参照',
            // メンバーNO
            member_no: '',
            // 氏名
            full_name: '',
            // レコードid
            id: '',
            // モーダルウィンドウの状態
            dialog: false,
            processing: false,
            // エラーメッセージ
            error: '',
            // カード一覧
            desserts: [],
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            data: {},
            // ゴルフグループ .env.VUE_APP_GROUP_CODEの値
            golf_groups_val: process.env.VUE_APP_GROUP_CODE,
            // MemberCardNoListのヘッダー
            headers: [
                { text: 'ゴルフ場', align: 'left', value: 'golf_name', sortable: false },
                { text: 'カード番号', align: 'left', value: 'card_no', sortable: false },
                { text: '', align: 'center', value: 'Btn', sortable: false }
            ],
            begin_row: 0,
            limit_rows: 5,
            Info: [],
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0006'
        };
    },
    watch: {
        adminInfo () {
            // ./modal/MemberCardNoModalにデータの変更を検知できるようにする
            this.adminInfo = Object.assign(this.adminInfo);
        }
    },
    methods: {
        getMemberCardList () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_MEMBER_CARD_LIST,
                variables: {
                    member_no: this.member_no,
                    golf_group_code: this.golf_groups_val,
                    begin_row: this.begin_row,
                    limit_rows: this.limit_rows
                }
            }).then(res => {
                const count = res.data.getMemberCardList.count;
                this.pageCount = Math.ceil(count / 5);
                this.desserts = res.data.getMemberCardList.MemberCardList;
            }).catch(error => {
                this.error = error;
            });
        },
        removeOverlayStart (item) {
            this.removeOverlay = true;
            this.id = item.id;
        },
        deleteMemberCardNo () {
            // 二重送信防止処理
            if (this.processing) return;

            this.processing = true;
            this.$apollo.mutate({
                mutation: DELETE_MEMBER_CARD_NO,
                variables: { id: this.id }
            }).then(res => {
                this.result = res.data.deleteCardNo.result;
                this.processing = false;
                this.removeOverlay = false;
                this.getMemberCardList();
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.remove');
                this.error = error;
                this.processing = false;
            });
        },
        /** ----------------------------------------------
         * モーダル表示処理 親コンポーネントで使用
         * ---------------------------------------------- */
        ModalControl (val, item) {
            this.Initialize();
            this.member_no = item.member_no;
            this.getAuthority();
            this.full_name = item.family_name + ' ' + item.given_name;
            this.getMemberCardList();
            this.dialog = val;
        },
        /** ----------------------------------------------
         * 入力欄のモーダルを登録状態で表示
         * ---------------------------------------------- */
        addModalDisplayOn () {
            this.golf_code = this.GolfCourseInput;
            this.$refs.Modal.addModal();
        },
        /** ----------------------------------------------
         * 入力欄のモーダルを編集状態で表示
         * ---------------------------------------------- */
        editModalDisplayOn (item) {
            this.Info = this.desserts.find(el => el.id === item.id);
            this.$refs.Modal.editModal();
        },
        /** ----------------------------------------------
         * モーダル非表示処理
         * ---------------------------------------------- */
        CloseModal () {
            this.Initialize();
            this.dialog = false;
            this.$emit('refresh-event');
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getMemberCardList();
        }
    }
};
</script>

<style scoped>
.cardWrap{
    margin: 0;
    padding: 20px 15px 15px;
    /* height: 500px; */
}

.v-card{
    box-shadow: none;
}

.titleMaxWidth{
    max-width: 60%;
}

.v-data-table{
    height:300px;
}

.v-data-table ::v-deep td{
    width: auto;
}

.v-data-table ::v-deep .v-text-field {
    padding-top: 10px;
    margin-top: 0px;
}

.v-data-table__wrapper ::v-deep .v-input__slot{
    margin-bottom: 0px;
}

.editBtn{
  color: #1B5E20;
  background: Transparent;
  text-decoration: underline;
  margin-right: 20px;
}

.deleteBtn {
  color: #d63200;
  background: Transparent;
  text-decoration: underline;
}

.buttonCell {
    min-width: 80px;
}
</style>
